/* When a piece is saved: the heart gives a small tick and the counter in the header follows. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('mj-save-piece button');
    if (!b) return;
    setTimeout(function () {
      if (b.getAttribute('aria-pressed') !== 'true') return;
      if (b.animate) b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.15)' }, { transform: 'scale(1)' }], { duration: 320, easing: 'ease-out' });
      document.querySelectorAll('[data-wishlist-count]').forEach(function (c) {
        if (c.animate) c.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 360, easing: 'ease-out' });
      });
    }, 0);
  });
})();
